// extracted by mini-css-extract-plugin
export var mw3dsFrame = "Mw3dsFrame-module--mw3dsFrame--50cf0";
export var visible = "Mw3dsFrame-module--visible--da81a";